type Props = {
  /** Render scale. */
  size?: 'sm' | 'md' | 'lg' | 'xl';
  /** Inverted palette for dark backgrounds (sidebar, dark hero, etc.). */
  tone?: 'on-light' | 'on-dark';
  /** Override the className applied to the root element. */
  className?: string;
};

/**
 * "CRM" wordmark. Single-line, no decorative typography.
 *
 * Inter SemiBold, tight tracking. Renders the same shape everywhere
 * (auth pages, sidebar, mobile top bar, landing hero) — only the size
 * and tone differ per context. The aria-label spells out "Client
 * Relationship Manager" so screen readers don't read three letters.
 */
export function Wordmark({ size = 'md', tone = 'on-light', className }: Props) {
  const rootSize: Record<NonNullable<Props['size']>, string> = {
    sm: 'text-base',
    md: 'text-2xl',
    lg: 'text-4xl',
    xl: 'text-6xl',
  };

  const fg = tone === 'on-dark' ? 'text-[#EEF4F8]' : 'text-graphite';

  return (
    <span
      className={
        'font-display font-semibold tracking-tight ' +
        rootSize[size] +
        ' ' +
        fg +
        (className ? ' ' + className : '')
      }
      aria-label="Client Relationship Manager"
    >
      CRM
    </span>
  );
}
